import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { NavLink, useLocation } from 'react-router';
import { twMerge } from 'tailwind-merge';
import { BLOG_LANG_COOKIE_NAME, BLOG_LANGS, BlogLangType } from '../../../types/blogTypes';
import { getBlogTrans } from '../../blogHooks/useBlogTrans';
import { Dropdown } from '../../uikit/Dropdown';
import { LanguagesIcon } from 'lucide-react';
import { useBlogContext } from '../BlogProvider';

export const BlogLangButton = observer(
    ({
        className,
        activeClassName,
        lang,
    }: {
        className?: string;
        activeClassName?: string;
        lang: BlogLangType;
    }) => {
        const location = useLocation();

        // 현재 경로가 언어 코드로 시작하는 경우 나머지 주소 유지
        const pathWithoutLang = useMemo(() => {
            const langRegex = new RegExp(`^/(${BLOG_LANGS.join('|')})`);

            if (langRegex.test(location.pathname)) {
                return location.pathname.replace(langRegex, '');
            }
            return '';
        }, [location.pathname, lang]);

        return (
            <NavLink
                to={`/${lang}${pathWithoutLang}`}
                className={({ isActive }) => twMerge(className, isActive && activeClassName)}
                onClick={() => {
                    document.cookie = `${BLOG_LANG_COOKIE_NAME}=${lang}; path=/; max-age=31536000`; // 1년 유지
                }}
            >
                {getBlogTrans('langName', lang)}
            </NavLink>
        );
    },
);

export const BlogLangDropdown = observer(({ direction }: { direction?: 'top' | 'bottom' }) => {
    const { lang: currentLang } = useBlogContext();

    return (
        <Dropdown
            button={
                <div className="flex items-center gap-2 text-sm">
                    <LanguagesIcon className="size-4" />
                    <span>Language</span>
                </div>
            }
            buttonClassName="font-normal min-w-30"
            direction={direction}
        >
            <ul className="menu">
                {BLOG_LANGS.map((lang) => (
                    <li key={lang} className={twMerge(lang === currentLang && 'text-primary')}>
                        <BlogLangButton lang={lang} />
                    </li>
                ))}
            </ul>
        </Dropdown>
    );
});
